import router from "./router";
import store from "./store";
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {tokensToRegexp} from "path-to-regexp";
import { wxLogin } from "@/api/wechat";
import { clearRequest } from "@/utils/request";

import { isMobile, getCurrentUrl } from "@/utils/tools";

NProgress.configure({showSpinner: false})

const whiteList = [
    "/",
    "/pc_index",
    "/mb_index",
    "/login",
    "/auth-redirect",
    "/news",
    "/download",
    "/privacy",
    "/agreement",
    // "/authors",
    // "/pano",
    /tour[/]\d/,
    /author[/]\d/,
    /news[/]\d/,
    /new[/]\d/
];

const expireFilterList = [
    "/member/pcpublish/index",
    "/edit",
    "/mobile/edit",
    "/mobile/publish",
]

router.beforeEach(async (to, from, next) => {
    while (clearRequest.clearArray.length > 0) {
        const item = clearRequest.clearArray.shift();
        try{
            const res = item('cancel requests while router change');
        } catch (err) {
            console.log("cancel error=>", err);
        }
    }
    NProgress.start()
    if (to.query.token) {
        await store.dispatch('setToken', to.query.token);
    }

    const token = store.getters.token;
    if (token && token!="") {
        if (!store.getters.userInfo) {
            try {
                // 判斷當前用戶是否已拉取完user_info信息
                const userInfo = await store.dispatch('getUserInfo');
                const accessRoutes = await store.dispatch('generateRoutes', userInfo);
                router.addRoutes(accessRoutes);
                next({...to, replace: true})
            } catch (e) {
                await store.dispatch('delUserAllInfo')
                console.log(e)
                // next({path: '/'})
                window.location.href = getCurrentUrl()
                NProgress.done()
            }
        }
    }

    
    const regs = [/tour[/]\d/];
    if(regs.find((reg => reg.test(to.path))) && to.query.code){
        try {
            let res = await wxLogin({code: to.query.code})
            if(res.data){
                store.commit('SET_WX_USER_INFO', res.data);
            }
            next({...to, ...{query: undefined}})
        } catch(e){
            console.log(e)
        }
    }

    if (whiteList.find((w => (typeof(w)=="string" && w===to.path) || (typeof(w)=="object" && w.test(to.path))))) {
        // 在免登錄白名單，直接進入
        next();
    } else {
        if (token) {
            //非管理員帳戶或者普通帳戶除去普通用戶外，需要判斷是否過期
            if (store.getters.userInfo && ((store.getters.userInfo.type !== 1 && store.getters.userInfo.type !== 3) || (store.getters.userInfo.type === 3 && store.getters.userInfo.level > 0)) && expireFilterList.indexOf(to.path) !== -1 ) {
                const expire_time = store.getters.userInfo.expire_time;
                const user_type = store.getters.userInfo.type;
                if (new Date().getTime() > new Date(expire_time).getTime()) {
                    if(isMobile()){
                        next({path: '/mobile/hintPage'})
                    }else{
                        if(user_type === 3){
                            next({path: '/member/hint/hintPage'})
                        }else{
                            next({path: '/agent/hint/hintPage'})
                        }
                    }
                }else{
                    next();
                }
            }else{
                next();

            }
        } else {
            // next({path: "/"})
            window.location.href = getCurrentUrl()
        }
    }
});

router.afterEach(() => {
    NProgress.done()
});
